import { Routes } from "@angular/router";
import { AuthGuard } from "../../core/guards/auth-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";

export const licenciasRoutes: Routes = [
  {
    path: "lic_inicio",
    loadComponent: () =>
      import("./components/inicio/inicio.component").then(
        (m) => m.InicioComponent
      ),
    data: {
      label: "Inicio",
      icon: "home",
      urlexterna: "LIC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lic_calendario",
    loadChildren: () =>
      import("./components/calendario/calendario.routes").then(
        (m) => m.calendarioRoutes
      ),
    data: {
      label: "Calendario",
      icon: "calendar_month",
      urlexterna: "LIC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lic_tipos-licencia",
    loadChildren: () =>
      import("./components/tipo_licencia/tipo_licencia.routes").then(
        (m) => m.tipoLicenciaRoutes
      ),
    data: {
      label: "Tipo_Licencias",
      icon: "receipt_long",
      urlexterna: "LIC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lic_solicitud",
    loadChildren: () =>
      import("./components/solicitud_licencia/solicitud_licencia.routes").then(
        (m) => m.solicitudLicenciaRoutes
      ),
    data: {
      label: "Solicitud_Licencia",
      icon: "post_add",
      urlexterna: "LIC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lic_gestion",
    loadChildren: () =>
      import("./components/gestion_licencias/gestion-licencias.routes").then(
        (m) => m.gestionLicenciasRoutes
      ),
    data: {
      label: "Gestion-Licencias",
      icon: "manage_accounts",
      urlexterna: "LIC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lic_importacion",
    loadChildren: () =>
      import(
        "./components/importacion_licencias/importacion-licencias.routes"
      ).then((m) => m.importacionLicenciasRoutes),
    data: {
      label: "Importacion-Licencias",
      icon: "upload_file",
      urlexterna: "LIC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lic_envio-liq",
    loadComponent: () =>
      import("./components/envio_liquidacion/envio-liquidacion.component").then(
        (m) => m.EnvioLiquidacionComponent
      ),
    data: {
      label: "Envio-Liquidacion",
      icon: "send",
      urlexterna: "LIC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
];
